/**
 * Joins a field name to a level depth ("type~1"). A dot would read as a nested form path to
 * react-hook-form.
 */
export const LEVEL_NAME_SEPARATOR = '~';
